<template>
  <div>
    <div class="Fuell-Toolbar">
      <ul class="Fuell-Tabs">
        <li class="Fuell-Tabs--tab">
          <router-link
            to="/budgets/active"
            class="Fuell-Tabs--link"
            active-class="active"
            v-t="{path: 'budgets_tabs_active_budgets'}"
          ></router-link>
        </li>
        <li class="Fuell-Tabs--tab">
          <router-link
            to="/budgets/archived"
            class="Fuell-Tabs--link"
            active-class="active"
            v-t="{path: 'budgets_tabs_archived_budgets'}"
          ></router-link>
        </li>
      </ul>

      <button
        @click="showCreateBudgetModal"
        class="Fuell-ToolbarButton blue ml-auto"
        v-if="isAdmin"
      >
        <span
          class="Fuell-ToolbarButton--label"
          v-t="{ path: 'budgets_new_budget'}"
        >
        </span>
      </button>
    </div>

    <router-view></router-view>
    <create-budget-modal
      :open.sync="showCreateBudgetModalFlag"
      v-if="showCreateBudgetModalFlag"
    ></create-budget-modal>
  </div>
</template>

<script>
import CreateBudgetModal from '../_components/_shared/CreateBudgetModal'

export default {
  name: 'BudgetsIndex',
  components: { CreateBudgetModal },
  data () {
    return {
      showCreateBudgetModalFlag: false
    }
  },
  methods: {
    showCreateBudgetModal () {
      this.showCreateBudgetModalFlag = true
    }
  },
  computed: {
    isAdmin () {
      return this.$store.getters['LoginStore/isAdmin']
    }
  }

}
</script>
